import { getMotivosEstudiante } from "../../services/apis_estudiante";
import { useState, useEffect } from "react";
import { Card, ListGroup, Spinner, Stack } from "react-bootstrap";
import Motivo from "../funcionarios/Motivo";
import AdministrarMotivosModal from "./AdministrarMotivosModal";

const styles = {
  card: {
    backgroundColor: "var(--color-background-3)",
    color: "var(--color-text)",
  },
};

function MotivosActuales({ motivos = [], onModulosChanged, onMotivosChanged }) {
  const [showMotivosModal, setShowMotivosModal] = useState(false);
  const handleOpenMotivosModal = () => setShowMotivosModal(true);
  const handleCloseMotivosModal = () => setShowMotivosModal(false);
  const motivosActivos = motivos.filter((m) => m.activo);

  return (
    <>
      <Card
        style={styles.card}
        className="p-4 h-100 d-flex flex-column shadow-sm border"
      >
        <p className="h3 mb-3">Motivos de Atención Activos
        </p>
        <Stack direction="vertical" gap={3} className="flex-grow-1">
          {motivosActivos.length === 0 ? (
            <p className="m-0 text-muted">
              No hay motivos visibles para los estudiantes
            </p>
          ) : (
            <Stack direction="horizontal" className="flex-wrap" gap={1}>
              {motivosActivos.map((motivo) => (
                <Motivo key={motivo.id} motivo={motivo.nombre} />
              ))}
            </Stack>
          )}
          <button
            className="btn btn-outline-secondary fw-semibold ms-auto"
            onClick={handleOpenMotivosModal}
          >
            <i className="bi bi-tags me-2"></i>
            Administrar Motivos
          </button>
        </Stack>
      </Card>

      {/* Modal de administración de motivos */}
      <AdministrarMotivosModal
        show={showMotivosModal}
        onClose={handleCloseMotivosModal}
        onMotivosChanged={() => {
          onModulosChanged?.();
          onMotivosChanged?.();
        }}
      />
    </>
  );
}
export default MotivosActuales;
